// extracted by mini-css-extract-plugin
module.exports = {"sidePanel":"sidePanel_sidePanel__2Bs1B","linkColor":"sidePanel_linkColor__2nVut","smallText":"sidePanel_smallText__n-45d","padding":"sidePanel_padding__257A3"};